import React, { forwardRef } from 'react';
import { Menu } from 'primereact/menu';
import classNames from 'classnames';
import styles from './ActionsMenu.module.scss';

/**
 * Row "..." actions popover: icon + label rows in a rounded card, with an
 * optional `danger` item styled in red. Thin wrapper around PrimeReact's
 * Menu — keeps its ref API (`toggle(event)` / `hide()`), positioning,
 * portal rendering and outside-click handling, but replaces PrimeIcons
 * items with our own icon components and styling via a custom template.
 *
 * `items`: [{ label, icon (react node), onClick, danger }]
 */
export const ActionsMenu = forwardRef(({ items = [] }, ref) => {
  const model = items.map((item) => ({
    label: item.label,
    command: item.onClick,
    template: (menuItem, options) => (
      <button
        type="button"
        role="menuitem"
        className={classNames(styles.actionItem, {
          [styles.actionItemDanger]: item.danger,
        })}
        onClick={options.onClick}
      >
        <span className={styles.actionIcon}>{item.icon}</span>
        {item.label}
      </button>
    ),
  }));

  return (
    <Menu model={model} popup ref={ref} className={styles.actionsMenuPanel} />
  );
});

ActionsMenu.displayName = 'ActionsMenu';
